import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WebSocketStore {

  private readonly _inProgress = signal<boolean>(false);

  readonly inProgress = this._inProgress.asReadonly();

  start(): void {
    this._inProgress.set(true);
  }

  stop(): void {
    this._inProgress.set(false);
  }
}
